import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { MessageCircle, Sparkles } from "lucide-react";
import { SendIcon } from "../../../assets/icon";
import {
  actionsRowSx,
  getModeSendButtonSx,
  getModeSendPillSx,
  modeButtonIconSx,
  modeButtonLabelSx,
  stickyBarSx,
  validationHintSx,
} from "./styles";

interface ConversationModePromptProps {
  readyToSend?: boolean;
  validationMessage?: string | null;
  onSendNew: () => void;
  onSendContinue: () => void;
}

export const ConversationModePrompt: React.FC<ConversationModePromptProps> = ({
  readyToSend = false,
  validationMessage = null,
  onSendNew,
  onSendContinue,
}) => {
  return (
    <Box sx={stickyBarSx} data-testid="conversation-mode-prompt">
      <Box sx={actionsRowSx}>
        <Button
          type="button"
          disableElevation
          disableRipple
          disabled={!readyToSend}
          onClick={onSendNew}
          sx={getModeSendButtonSx(!readyToSend)}
          aria-label="Start new conversation and send"
        >
          <Box component="span" sx={modeButtonIconSx}>
            <Sparkles size={15} strokeWidth={2.25} />
          </Box>
          <Box component="span" sx={modeButtonLabelSx}>
            New conversation
          </Box>
          <Box
            component="span"
            className="mode-send-pill"
            sx={getModeSendPillSx(readyToSend)}
          >
            <SendIcon width="14px" height="14px" />
          </Box>
        </Button>

        <Button
          type="button"
          disableElevation
          disableRipple
          disabled={!readyToSend}
          onClick={onSendContinue}
          sx={getModeSendButtonSx(!readyToSend)}
          aria-label="Continue previous conversation and send"
        >
          <Box component="span" sx={modeButtonIconSx}>
            <MessageCircle size={15} strokeWidth={2.25} />
          </Box>
          <Box component="span" sx={modeButtonLabelSx}>
            Continue conversation
          </Box>
          <Box
            component="span"
            className="mode-send-pill"
            sx={getModeSendPillSx(readyToSend)}
          >
            <SendIcon width="14px" height="14px" />
          </Box>
        </Button>
      </Box>
      {validationMessage ? (
        <Typography sx={validationHintSx} role="alert">
          {validationMessage}
        </Typography>
      ) : null}
    </Box>
  );
};
